import { Button, type ButtonProps } from '@mui/material'

interface CustomLoadingButtonProps extends ButtonProps {
  children: React.ReactNode
  isLoading: boolean
  icon?: React.ReactNode
  iconPosition?: 'start' | 'end'
}

function CustomLoadingButton({
  children,
  isLoading,
  icon,
  iconPosition = 'end',
  ...restProps
}: Readonly<CustomLoadingButtonProps>) {
  return (
    <Button
      loading={isLoading}
      loadingPosition={iconPosition}
      variant="contained"
      size="large"
      disableElevation
      {...(iconPosition === 'start' && { startIcon: icon })}
      {...(iconPosition === 'end' && { endIcon: icon })}
      {...restProps}
    >
      {children}
    </Button>
  )
}

export default CustomLoadingButton
